import dayjs from 'dayjs';
import { ICareMap } from '../caremap/ICareMap';

const SURVEY_BASE_URL = 'https://tally.so/r/xXrgVG';

interface IGetHelpUrlParams {
    email?: string;
    firstName?: string;
    lastName?: string;
    caremap?: ICareMap;
    source: 'card' | 'popup';
}

export const buildGetHelpSurveyUrl = ({
    email,
    firstName,
    lastName,
    caremap,
    source
}: IGetHelpUrlParams): string => {
    const params = new URLSearchParams();

    if (email) {
        params.append('email', email);
    }

    if (firstName) {
        params.append('first_name', firstName);
    }

    if (lastName) {
        params.append('last_name', lastName);
    }

    if (caremap?.patient) {
        const patient = caremap.patient;

        if (patient.address) {
            params.append('location', patient.address);
        }

        if (patient.diagnoses && patient.diagnoses.length > 0) {
            const diagnosesStr = patient.diagnoses.map(d => d.diagnosis).join('|');
            params.append('diagnoses', diagnosesStr);
        }

        if (patient.dob) {
            params.append('care_recipient_dob', patient.dob);
            const age = dayjs().diff(dayjs(patient.dob), 'year');
            params.append('care_recipient_age', String(age));
        }

        if (patient.firstName) {
            params.append('care_recipient_name', patient.firstName);
        }
    }

    params.append('source', source);
    params.append('response', 'Yes');

    const queryString = params.toString();
    return queryString ? `${SURVEY_BASE_URL}?${queryString}` : SURVEY_BASE_URL;
};
